import { render, staticRenderFns } from "./GroupFeaturedMembersConfig.vue?vue&type=template&id=5874418e&"
import script from "./GroupFeaturedMembersConfig.vue?vue&type=script&lang=js&"
export * from "./GroupFeaturedMembersConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports